import styled, { css } from "styled-components"
import { Link } from "gatsby"

export const GatsbyLink = styled(Link)`
  color: white;

  ${props =>
    props.active
      ? css`
          background: white;
          color: var(--clr-purple);
        `
      : ""}
`

export const ResponsiveMenu = styled.ul`
  width: 100%;
  min-width: 250px;
  max-width: 250px;
  height: 100vh;
  padding: 0 15px;
  float: right;
  background: var(--clr-purple);
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  overflow: hidden;
  -webkit-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  -webkit-transform: translate3d(200px, 0, 0);
  transform: translate3d(200px, 0, 0);
  list-style: none;
  -webkit-border-radius: 5px 0 0 5px;
  border-radius: 5px 0 0 5px;
  visibility: hidden;
  padding-top: var(--gapS);

  h2 {
    color: white;
    font-size: var(--fontSize-1);
    margin-bottom: var(--gapXS);
    text-align: center;
  }

  a,
  button {
    position: relative;
    pointer-events: visible;
    display: inline-block;
    font-weight: normal;
    width: 100%;
    padding: 7.5px 5px;
    border-radius: var(--border-radius);
  }

  a:hover,
  a :focus {
    background: white;
    color: var(--clr-purple);
  }

  & > * {
    margin-bottom: 20px;
  }

  ${props =>
    props.show
      ? css`
          -webkit-transform: translate3d(0, 0, 0);
          transform: translate3d(0, 0, 0);
          visibility: visible;
        `
      : ""}
`

export const Submenu = styled.ul`
  display: none;
  visibility: hidden;
  position: absolute;
  top: 40px;
  width: 100%;
  padding: 10px 0;
  border-radius: var(--border-radius);
  background: var(--clr-white-purple-rgba);
  box-shadow: var(--box-shadow);

  li {
    margin-bottom: 10px;

    & a {
      padding-left: 10px;
      width: 100%;
      border-radius: var(--border-radius);
    }

    & a:hover,
    & a:focus {
      background: white;
    }

    & :last-child {
      margin-bottom: 0;
    }
  }

  ${props =>
    props.active
      ? css`
          display: block;
          visibility: visible;
        `
      : ""}
`

export const LeistungsButtonContainer = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  align-items: center;
  position: relative;
  padding: 2.5px 0;
  -webkit-border-radius: var(--border-radius);
  -moz-border-radius: var(--border-radius);
  border-radius: var(--border-radius);

  svg {
    position: absolute;
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    transform: rotate(90deg);
    width: 18px;
    height: 18px;
    margin-left: auto;
    margin-top: 2px;
    margin-right: 5px;
    right: 0;

    & * {
      stroke: white;
      stroke-width: 4px;
    }

    ${props =>
      props.show
        ? css`
            -webkit-transform: rotate(-90deg);
            -moz-transform: rotate(-90deg);
            -o-transform: rotate(-90deg);
            transform: rotate(-90deg);
          `
        : ""}
  }

  &:hover,
  &:focus {
    background: white;

    & svg * {
      stroke: var(--clr-purple);
    }

    & > * {
      color: var(--clr-purple);
    }
  }

  ${props =>
    props.show
      ? css`
          margin-bottom: 150px;
        `
      : ""}

  ${props =>
    props.show && props.bigger
      ? css`
          margin-bottom: 200px;
        `
      : ""}

  ${props =>
    props.active
      ? css`
          background: white;
          button {
            color: var(--clr-purple);
          }

          svg * {
            stroke: var(--clr-purple);
          }
        `
      : ""}
`

export const LeistungenButton = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-weight: bold;
  text-align: left;

  ${props =>
    props.active
      ? `
    background: white;
    color: var(--clr-purple);
`
      : ""}
`

export const ResponsiveMenuContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.2);
  opacity: 0;
  -webkit-transition: all 0.3s ease-in;
  -o-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
  z-index: -10;
  pointer-events: none;
  visibility: hidden;

  ${props =>
    props.show
      ? css`
          opacity: 1;
          z-index: 10;
          pointer-events: visible;
          visibility: visible;
        `
      : ""}
`
